import { render } from "./ExceptionReport.vue?vue&type=template&id=0d6c7564"
import script from "./ExceptionReport.vue?vue&type=script&lang=js"
export * from "./ExceptionReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__